import {
    SET_COUNTRY,
    SET_STATE,
    SET_EMAIL,
    SET_ERROR,
    SET_PAGE_LOADING,
    SET_PROCESS_LOADING,
    SET_TOGGLE,
    SET_SUCCESS,
    SET_UPDATE_PASSWORD_ERROR,
    SET_BANKS,
    SET_MODAL,
    SET_404,
    SET_DETAIL_NOT_FOUND,
    SET_RANDOM_ACTION,
    UPLOAD_KYC_WITH_BVN,
    UPLOAD_KYC_WITH_BVN_SUCCESS,
    UPLOAD_KYC_WITH_BVN_FAILURE,
    SET_BUTTON_LOADING
} from './actionTypes';

const initialState = {
    error404: false,
    addCustomerModal: false,
    addNewBankModal: false,
    allBanks: [],
    allStates: [],
    bankModal: false,
    businessModal: false,
    country: [],
    createPlanModal: false,
    detailsNotFound: false,
    deletePaymentLinkModal: false,
    editChargeModal: false,
    email: '',
    errorProfileVerification: '',
    requestInvoiceModal: false,
    simpleInvoiceModal: false,
    subscriptionLinkModal: false,
    addInvoiceItemModal: false,
    invoiceDetailsModal: false,
    sendInvoiceRequestModal: false,
    deleteInvoiceModal: false,
    editSimpleInvoiceModal: false,
    isToggled: false,
    loading: false,
    pageLoading: false,
    processLoading: false,
    buttonLoading: false,
    profileModal: false,
    singleChargeModal: false,
    success: '',
    updatePasswordError: '',
    updateBankModal: false,
    updatePasswordModal: false,
    editPlanModal: false,
    deletePlanModal: false,
    deleteBankAccountModal: false,
    updateCustomerModal: false,

    uploadingKycWithBVN: false,
    uploadingKycWithBVNSuccess: false,
    uploadingKycWithBVNFailed: false,
    createDirectDebitModal: false,
    editDirectDebitModal: false,
    deleteDirectDebitModal: false,
    error: ''
};

const util = (state = initialState, action) => {
    switch (action.type) {
        case SET_DETAIL_NOT_FOUND:
            state = { ...state, detailsNotFound: action.payload };
            break;
        case SET_404:
            state = { ...state, error404: action.payload };
            break;
        case SET_MODAL:
            state = { ...state, ...action.payload };
            break;
        case SET_RANDOM_ACTION:
            state = { ...state, ...action.payload };
            break;
        case SET_BANKS:
            state = { ...state, allBanks: action.payload.content };
            break;
        case SET_UPDATE_PASSWORD_ERROR:
            state = { ...state, updatePasswordError: action.payload };
            break;
        case SET_SUCCESS:
            state = { ...state, success: action.payload };
            break;
        case SET_TOGGLE:
            state = { ...state, isToggled: !state.isToggled };
            break;
        case SET_STATE:
            state = { ...state, allStates: action.payload };
            break;
        case SET_COUNTRY:
            state = { ...state, country: action.payload };
            break;
        case SET_EMAIL:
            state = { ...state, email: action.payload };
            break;
        case SET_ERROR:
            state = { ...state, error: action.payload };
            break;
        case SET_PROCESS_LOADING:
            state = { ...state, processLoading: action.payload };
            break;
        case SET_BUTTON_LOADING:
            state = { ...state, buttonLoading: action.payload };
            break;
        case SET_PAGE_LOADING:
            state = { ...state, pageLoading: action.payload };
            break;

        case UPLOAD_KYC_WITH_BVN:
            return { ...state, uploadingKycWithBVN: true };
        case UPLOAD_KYC_WITH_BVN_SUCCESS:
            return {
                ...state,
                uploadingKycWithBVN: false,
                uploadingKycWithBVNSuccess: true
            };
        case UPLOAD_KYC_WITH_BVN_FAILURE:
            return {
                ...state,
                uploadingKycWithBVN: false,
                uploadingKycWithBVNSuccess: false,
                uploadingKycWithBVNFailed: true,
                error: action.payload
            };

        default:
            state = { ...state };
            break;
    }
    return state;
};

export default util;
